'use strict';

// CSS bundlés (pas CDN)
import '@fontsource/plus-jakarta-sans/200.css';
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/plus-jakarta-sans/800.css';
import 'material-icons/iconfont/material-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'font-awesome/css/font-awesome.min.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

// Leaflet exposé globalement avant angular-leaflet-directive
import L from 'leaflet';
import 'leaflet.markercluster';
window.L = L;

// jQuery est exposé globalement par ProvidePlugin (webpack.common.js)

// Import Angular et ses dépendances
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'angular-resource';
import 'angular-cookies';
import 'angular-sanitize';
import 'angular-messages';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'ng-file-upload';
import 'ng-infinite-scroll';
import Chart from 'chart.js';
window.Chart = Chart;
import 'angular-chart.js';
import 'angular-ui-bootstrap';

// Bibliothèques d'exportation exposées globalement
import * as XLSX from 'xlsx';
window.XLSX = XLSX;
import jsPDF from 'jspdf';
window.jsPDF = jsPDF;
import 'jspdf-autotable';

// Nom du module principal
const MODULE_NAME = 'observatoireApp';

// Création du module principal avec ses dépendances
angular.module(MODULE_NAME, [
  uiRouter,
  'ngResource',
  'ngCookies',
  'ngSanitize',
  'ngMessages',
  'pascalprecht.translate',
  'ngFileUpload',
  'chart.js',      // Module pour les graphiques
  'infinite-scroll',
  'ui.bootstrap',
  'chatbotModule'  // Module du chatbot
]);

// Export du module pour son utilisation dans d'autres fichiers
export default MODULE_NAME;
